import { GrantActivityItemDto } from "../../dtos/GrantActivityItemDto";
import { ApiResult, apiWrapperWithError } from "./ApiUtils";

export const getGrantOverview = async (grantId: string): Promise<ApiResult<GrantActivityItemDto[]> | null> => {
    return apiWrapperWithError<GrantActivityItemDto[]>(`api/overview/grant/${grantId}`, 'GET', `fetching overview for grant ${grantId}`);
}
